const fr: Record<string, string> = {
  'features.recipes.empty': 'Aucune recette pour le moment. Ajoutez-en une pour commencer.',
  'features.recipes.newRecipe': 'Nouvelle recette',
  'features.recipes.name': 'Nom',
  'features.recipes.namePlaceholder': 'ex. Lasagnes',
  'features.recipes.servings': 'Portions',
  'features.recipes.servingsCount': '{{count}} portions',
  'features.recipes.description': 'Description',
  'features.recipes.labels': 'Étiquettes',
  'features.recipes.newLabel': 'Nouvelle étiquette',
  'features.recipes.configureLabels': 'Configurer les étiquettes',
  'features.recipes.doneConfiguringLabels': 'Terminer la configuration',
  'features.recipes.ingredients': 'Ingrédients',
  'features.recipes.noIngredients': "Aucun ingrédient pour le moment.",
  'features.recipes.addIngredient': 'Ajouter un ingrédient',
  'features.recipes.removeIngredient': "Retirer l'ingrédient",
  'features.recipes.moveIngredientUp': 'Monter',
  'features.recipes.moveIngredientDown': 'Descendre',
  'features.recipes.ingredientSearchLabel': 'Ingrédient',
  'features.recipes.searchIngredientPlaceholder': 'Rechercher un ingrédient…',
  'features.recipes.noFoodSections': "Aucun rayon alimentaire dans le catalogue pour l'instant.",
  'features.recipes.noCatalogMatch': 'Aucun article du catalogue ne correspond à « {{query}} ».',
  'features.recipes.addToCatalogAction': 'Ajouter « {{query}} » au catalogue',
  'features.recipes.addToCatalogHelp': 'Il sera créé dans le catalogue partagé des courses, avec le rayon choisi ci-dessous.',
  'features.recipes.notInCatalogAction': "Cet ingrédient ne sera pas dans le catalogue",
  'features.recipes.notInCatalogHelp': 'Utilisé seulement pour cette recette — non enregistré dans le catalogue partagé des courses.',
  'features.recipes.customIngredientName': "Nom de l'ingrédient",
  'features.recipes.customIngredientUnit': 'Unité',
  'features.recipes.customIngredientSection': 'Rayon',
  'features.recipes.customIngredientSectionPlaceholder': 'Aucun rayon (optionnel)',
  'features.recipes.changeIngredient': 'Changer',
  'features.recipes.quantity': 'Quantité',
  'features.recipes.displayOverride': 'Texte personnalisé',
  'features.recipes.displayOverridePlaceholder': 'ex. une pincée',
  'features.recipes.isAccompaniment': 'Ceci est un accompagnement',
  'features.recipes.isAccompanimentHelp': "Ne fait pas partie de la recette à proprement parler, mais est suggéré pour l'accompagner (ex. du pain avec une soupe). Ajouté à une liste de courses un par un, pas avec les ingrédients principaux de la recette.",
  'features.recipes.accompaniments': 'Accompagnements',
  'features.recipes.condiments': 'Condiments',
  'features.recipes.add': 'Ajouter',
  'features.recipes.create': 'Créer',
  'features.recipes.cancel': 'Annuler',
  'features.recipes.back': 'Retour',
  'features.recipes.backToList': 'Retour aux recettes',
  'features.recipes.readMode': 'Mode lecture',
  'features.recipes.editRecipe': 'Modifier la recette',
  'features.recipes.state.draft': 'Brouillon',
  'features.recipes.state.completed': 'Terminée',
  'features.recipes.markCompleted': 'Marquer comme terminée',
  'features.recipes.searchPlaceholder': 'Rechercher une recette ou un ingrédient…',
  'features.recipes.ingredientFilterPlaceholder': 'Filtrer par ingrédient',
  'features.recipes.difficulty.label': 'Difficulté',
  'features.recipes.difficulty.level0': 'Très facile',
  'features.recipes.difficulty.level1': 'Facile',
  'features.recipes.difficulty.level2': 'Modérée',
  'features.recipes.difficulty.level3': 'Intermédiaire',
  'features.recipes.difficulty.level4': 'Difficile',
  'features.recipes.difficulty.level5': 'Très difficile',
  'features.recipes.clearDifficultyFilter': 'Réinitialiser',
  'features.recipes.prepTime': 'Temps de préparation',
  'features.recipes.totalTime': 'Temps total',
  'features.recipes.prepTimeValue': 'Préparation : {{time}}',
  'features.recipes.totalTimeValue': 'Total : {{time}}',
  'features.recipes.minutesShort': '{{count}} min',
  'features.recipes.hoursShort': '{{count}} h',
  'features.recipes.hoursMinutesShort': '{{hours}} h {{minutes}}',
  'features.recipes.components': 'Compositions',
  'features.recipes.addComponent': 'Ajouter une composition',
  'features.recipes.removeComponent': 'Retirer la composition',
  'features.recipes.componentRecipe': 'Recette',
  'features.recipes.selectComponentRecipe': 'Sélectionner une recette…',
  'features.recipes.multiplier': 'Multiplicateur',
  'features.recipes.multiplierHelp': 'Combien de fois utiliser cette recette (ex. 2 pour une double portion).',
  'features.recipes.componentMultiplier': '×{{multiplier}}',
};

export default fr;
